<template>
  <eg-b-dropdown
    ref="dropdown"
    :size="size"
    :disabled="disabled"
    block
    toggle-class="filter-dropdown"
    :menu-class="menuClass"
    variant="n"
    :split="split"
    :dropup="dropup"
    :boundary="boundary"
    :right="right"
    @show="onShow"
    @hide="onHide"
  >
    <template #button-content>
      <slot
        v-if="$scopedSlots['button-content']"
        name="button-content"
        :toggle="toggle"
      />
      <div v-else class="d-flex align-items-center justify-content-between">
        <span class="text-truncate">{{ text }}</span>
        <eg-b-icon class="fs-10 ml-1" icon="chevron-down"></eg-b-icon>
      </div>
    </template>
    <div class="items-wrapper">
      <slot />
    </div>
  </eg-b-dropdown>
</template>

<script>
function isFocusable(el) {
  const cs = window.getComputedStyle(el, null);
  if (
    cs.getPropertyValue("visibility") == "hidden" ||
    cs.getPropertyValue("display") == "none"
  )
    return false;
  const natively =
    'a[href], area[href], details, iframe, :is(button, input:not([type="hidden"]), select, textarea)';

  if (
    el.matches(natively) ||
    (el.hasAttribute("tabindex") &&
      parseInt(el.getAttribute("tabindex")) >= 0) ||
    el.isContentEditable
  )
    return true;
  return false;
}

export default {
  name: "EgDropdown",
  props: {
    text: {
      type: String,
      default: "",
    },
    split: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "md",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    dropup: {
      type: Boolean,
      default: false,
    },
    menuClass: {
      type: String,
      default: "",
    },
    boundary: {
      type: String,
      default: "scrollParent",
    },
    right: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      openTargetElement: null,
    };
  },

  methods: {
    update() {
      this.$refs.dropdown?.$_popper?.update();
    },

    toggle(e) {
      const isVisible = this.$refs.dropdown.visible;
      isVisible ? this.hide(e) : this.show(e);
    },

    show(e) {
      if (isFocusable(e.target)) {
        this.openTargetElement = e.target;
      }

      this.$refs.dropdown && this.$refs.dropdown.show();
    },

    hide() {
      this.openTargetElement = null;
      this.$refs.dropdown && this.$refs.dropdown.hide();
    },

    onShow(e) {
      if (this.openTargetElement) {
        // twice because need to wait opened popover (part of vue bootstrap)
        this.$nextTick(() => {
          this.$nextTick(() => {
            this.openTargetElement.focus();
          });
        });
      }

      this.$emit("show", e);
    },

    onHide(e) {
      if (this.openTargetElement) {
        e.preventDefault();
        this.openTargetElement = null;
      } else {
        this.openTargetElement = null;
      }

      this.$emit("hide", e);
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdown {
  &::v-deep {
    .dropdown-toggle {
      &::after {
        display: none;
      }
    }
  }
}
</style>

<style lang="scss">
.cancel-default-disabled-styles .dropdown-toggle.disabled {
  opacity: 1;
}

.dropdown-menu {
  padding: 0 !important;
  margin: 0 !important;
  min-width: 168px !important;
  border: 1px solid var(--color-stroke-neutral-default) !important;
  box-shadow: 0 2px 6px 2px #0000000f;

  &.rubric-select-menu {
    > .items-wrapper {
      padding: 0 8px 8px 8px;

      .dropdown-header {
        text-align: center;
      }

      .dropdown-item {
        font-size: 14px;
        padding: 10px;
      }
    }
  }

  .items-wrapper {
    margin: 0;
    display: flex;
    flex-direction: column;

    li {
      margin: 0;
    }

    .dropdown-divider {
      margin: 0;
    }

    .b-dropdown-text {
      padding: 0 !important;
    }

    .top-content {
      display: flex;
      flex-direction: column;
      gap: 4px;
      align-items: flex-start;
      padding: 12px 12px 8px 12px;
    }
  }

  .dropdown-item {
    display: flex;
    gap: 8px;
    align-items: center;
    border-radius: 0.25rem;
    padding: 12px;
    transition: background-color 1.4s cubic-bezier(0.25, 1, 0.5, 1);
    overflow: hidden;
    color: var(--color-text-neutral-on-white, #1c0f30);
    text-overflow: ellipsis;
    white-space: nowrap;
    font-family: var(--typography-font-family-text-primary, Inter);
    font-size: var(--typography-font-size-fs-300);
    font-style: normal;
    font-weight: var(--typography-font-weight-fw-400, 400);
    line-height: 120%; /* 14.4px */

    &:hover {
      background-color: hsl(258, 100%, 97%);
    }

    &.active,
    &:active {
      color: inherit;
    }
  }
}
</style>
